export const CONSTANTS = {
  REPORTS_BUTTON_TEXT: $localize`Submit`,
  CANCEL: $localize`Cancel`,
  BACK: $localize`Back`,
};

export type ButtonInfo = {
  text?: string;
  imageSrc?: string;
  disable?: boolean;
  type: BUTTON_TYPES;
};

export enum BUTTON_TYPES {
  NONE,
  REPORT_BUTTON,
  CANCEL_BUTTON,
  BACK_BUTTON,
  TEXT_BUTTON,
  ICON_BUTTON,
  ICON_TEXT_BUTTON,
}
